
import React, { useState } from "react";
import { useEffect } from "react";
import './styles/player.css';


function Player({playerName, playerMoney,mianWallet}) {

    // console.log("in Player")

    const [count, setCount] = useState();
    useEffect(()=>{
        setCount(playerMoney);
    },[playerMoney]);
   
    return(
        <div className="playerTag">
            <div className="playerImage" >
                <div className="backgroundfortext">
                    <div className="mainWalletText" id="bank">
                        {"$"+mianWallet}    
                    </div>
                </div>
            </div>
            <div className="playerName">{playerName}</div>
            <div className="playerWallet">${count}</div>
        </div>
    );
    
}

export default Player